import React, { useEffect, useState } from 'react';
import { validateFunctionalForm } from '../../../utils';
import { v2_countries, v2_states, v2_state_districts } from '../../../actions/v2/masterData';

const SubContractorForm = ({ data, onSubmit, title }) => {
    const [state, setState] = useState({
        subContractorName: { name: 'subContractorName', value: data?.SUB_CONTRACTOR_NAME || '', isRequired: true, error: '' },
        subContractorCode: { name: 'subContractorCode', value: data?.SUB_CONTRACTOR_CODE || '', isRequired: true, error: '' },
        contactPerson: { name: 'contactPerson', value: data?.CONTACT_PERSON || '', isRequired: false, error: '' }, // <-- New Field
        country: { name: 'country', value: data?.COUNTRY_ID || '', options: [], isRequired: false, error: '' },
        stateField: { name: 'stateField', value: data?.STATE_ID || '', options: [], isRequired: false, error: '' },
        city: { name: 'city', value: data?.CITY_ID || '', options: [], isRequired: false, error: '' },
        address: { name: 'address', value: data?.ADDRESS || '', isRequired: false, error: '' },
        email: { name: 'email', value: data?.EMAIL || '', isRequired: false, error: '' },
        contactNumber: { name: 'contactNumber', value: data?.CONTACT_NUMBER || '', isRequired: false, error: '' },
        note: { name: 'note', value: data?.NOTE || '', isRequired: false, error: '' },
        isActive: { name: 'isActive', value: data?.IS_ACTIVE ?? true, isRequired: false },
    });

    useEffect(() => {
        v2_countries().then((res) => {
            if (res.status) {
                const options = res.result.map((item) => ({
                    label: item.NAME,
                    value: item.ID,
                }));
                setOptions('country', options);
            }
        });
    }, []);

    useEffect(() => {
        if (state.country.value) {
            v2_states(state.country.value).then((res) => {
                if (res.status) {
                    const options = res.result.map((item) => ({
                        label: item.NAME,
                        value: item.ID,
                    }));
                    setOptions('stateField', options);
                    setOptions('city', []);
                }
            });
        }
    }, [state.country.value]);

    useEffect(() => {
        if (state.stateField.value) {
            v2_state_districts(state.stateField.value).then((res) => {
                if (res.status) {
                    const options = res.result.map((item) => ({
                        label: item.NAME,
                        value: item.ID,
                    }));
                    setOptions('city', options);
                }
            });
        }
    }, [state.stateField.value]);

    const setOptions = (name, options) => {
        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                options: options,
            }
        }));
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;

        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: val,
                error: prev[name].isRequired && !val ? 'This field is required' : ''
            }
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {};
            Object.keys(state).forEach(key => {
                model[key] = state[key].value;
            });
            if (data?.ID) model.id = data.ID;
            onSubmit(model);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            {/* <h4 className="card-title mb-4">{title}</h4> */}
            <div className="row">
                {[
                    { label: 'Sub Contractor Name', name: 'subContractorName', placeholder: 'Enter Sub Contractor name', type: 'text' },
                    { label: 'Sub Contractor Code', name: 'subContractorCode', placeholder: 'Enter Sub Contractor code', type: 'text' },
                    { label: 'Contact Person', name: 'contactPerson', placeholder: 'Enter contact person', type: 'text' }, // <-- New Field
                    { label: 'Country', name: 'country', type: 'select' },
                    { label: 'State', name: 'stateField', type: 'select' },
                    { label: 'City', name: 'city', type: 'select' },
                    { label: 'Address', name: 'address', placeholder: 'Enter address', type: 'text' },
                    { label: 'Email', name: 'email', placeholder: 'Enter email', type: 'text' },
                    { label: 'Contact Number', name: 'contactNumber', placeholder: 'Enter contact number', type: 'text' },
                ].map(({ label, name, placeholder, type }) => (
                    <div className="col-md-6 mb-3" key={name}>
                        <label>{label} {state[name]['isRequired'] ? <span className='text-danger'> * </span> : ''}</label>
                        {type === 'select' ? (
                            <select
                                name={state[name].name}
                                value={state[name].value}
                                onChange={handleChange}
                                className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
                            >
                                <option value="">-- Select {label} --</option>
                                {state[name].options.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                        ) : (
                            <input
                                type={type}
                                name={state[name].name}
                                value={state[name].value}
                                onChange={handleChange}
                                placeholder={placeholder}
                                className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
                            />
                        )}
                        {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
                    </div>
                ))}

                <div className="col-md-12 mb-3">
                    <label>Note</label>
                    <textarea
                        name={state.note.name}
                        value={state.note.value}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Enter any notes"
                        rows="3"
                    />
                </div>

                <div className="col-md-4 form-check ms-2">
                    <input
                        type="checkbox"
                        name={state.isActive.name}
                        checked={state.isActive.value}
                        onChange={handleChange}
                        className="form-check-input"
                        id="isActive"
                    />
                    <label className="form-check-label" htmlFor="isActive">Active</label>
                </div>
            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Save</button>
                <button type="reset" className="btn btn-danger">Cancel</button>
            </div>
        </form>
    );
};

export default SubContractorForm;
